module.exports = __webpack_public_path__ + "assets/img/1602_06.jpg?253880f7b95f9c75ed7b2a69388b1975";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1602_06.jpg
// module id = 1103
// module chunks = 0